import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { SectionContainer, StyledTextInput } from 'components/shared';

import styles from './AddInternalOrderIdSection.module.css';

type AddInternalOrderIdSectionProps = {
   internalOrderId: string;
   onChangeInternalOrderId: (event: ChangeEvent<HTMLInputElement>) => void;
};

const AddInternalOrderIdSection = ({
   internalOrderId,
   onChangeInternalOrderId,
}: AddInternalOrderIdSectionProps) => {
   const { t } = useTranslation();

   return (
      <SectionContainer title={t('order_summary.internal_order_id')}>
         <p className={styles.infoText}>{t('add_internal_order_id.description')}</p>
         <StyledTextInput
            name="internalOrderId"
            value={internalOrderId}
            type="text"
            onChange={onChangeInternalOrderId}
            label={t('add_internal_order_id.input_label')}
            className={styles.input}
         />
      </SectionContainer>
   );
};

export default AddInternalOrderIdSection;
